// extracted by mini-css-extract-plugin
module.exports = {"disc":"e_Pk","accent":"e_Qk","empty":"e_Rk","s32":"e_Sk","s36":"e_Tk","s44":"e_Uk","s56":"e_Vk","s72":"e_Wk"};